'use client';

import _defineProperty from "/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["forceMount"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useEffect } from 'react';
import { useDebouncedCallback } from '@mantine/hooks';
import { useScrollAreaContext } from '../ScrollArea.context.mjs';
import { composeEventHandlers } from '../utils/compose-event-handlers.mjs';
import { ScrollAreaScrollbarVisible } from './ScrollAreaScrollbarVisible.mjs';
var ScrollAreaScrollbarScroll = forwardRef(function (props, red) {
  var forceMount = props.forceMount,
    scrollbarProps = _objectWithoutProperties(props, _excluded);
  var context = useScrollAreaContext();
  var isHorizontal = props.orientation === "horizontal";
  var _useState = useState("hidden"),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var debounceScrollEnd = useDebouncedCallback(function () {
    return setState("idle");
  }, 100);
  useEffect(function () {
    if (state === "idle") {
      var hideTimer = window.setTimeout(function () {
        return setState("hidden");
      }, context.scrollHideDelay);
      return function () {
        return window.clearTimeout(hideTimer);
      };
    }
    return void 0;
  }, [state, context.scrollHideDelay]);
  useEffect(function () {
    var viewport = context.viewport;
    var scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
    if (viewport) {
      var prevScrollPos = viewport[scrollDirection];
      var handleScroll = function handleScroll() {
        var scrollPos = viewport[scrollDirection];
        var hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
        if (hasScrollInDirectionChanged) {
          setState("scrolling");
          debounceScrollEnd();
        }
        prevScrollPos = scrollPos;
      };
      viewport.addEventListener("scroll", handleScroll);
      return function () {
        return viewport.removeEventListener("scroll", handleScroll);
      };
    }
    return void 0;
  }, [context.viewport, isHorizontal, debounceScrollEnd]);
  if (forceMount || state !== "hidden") {
    return /* @__PURE__ */jsx(ScrollAreaScrollbarVisible, _objectSpread(_objectSpread({
      "data-state": state === "hidden" ? "hidden" : "visible"
    }, scrollbarProps), {}, {
      ref: red,
      onPointerEnter: composeEventHandlers(props.onPointerEnter, function () {
        return setState("interacting");
      }),
      onPointerLeave: composeEventHandlers(props.onPointerLeave, function () {
        return setState("idle");
      })
    }));
  }
  return null;
});
export { ScrollAreaScrollbarScroll };